export const validateForm = (idForm) => {
  
}

export const a = 1;

const quantities = ['qty1', 'qty2', 'qty3', 'qty4'];

export const isParameterNameQtyValid = (name) => {
  return quantities.includes(name);
}

export const isProductTypeParameterNameQtyValid = (name, product_type) => {
  return quantities.map((q) => `${product_type}_${q}`).includes(name);
}
